module.exports = __webpack_public_path__ + "images/blog/blog_card/fixed_page_no_image_f8af62f9ee7b806259df4406e6ac8a5f.jpg";